import { Store } from './store'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first } from 'rxjs/operators'

import { User } from 'app/models'

import { Mapper } from './mapper.service'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class UserService extends Store<User> {

  constructor(private api: ApiService) {
    super(null)
  }

  public findCurrent(): void {
    this.getUser().pipe(first())
      .subscribe(
        (data: any) => {
          const user = Mapper.as<User>((data.result && data.result.user) || { }, User)
          this.setCurrent(user)
        },
        error => {
          this.setCurrent(new User({ }))
        }
      )
  }

  public getUser(): Observable<User> {
    return this.api.get('oauth/me')
  }

  public async getOrphanInvites(): Promise<any> {
    return this.api.get('orphan_invites/mine').toPromise()
  }
}
